export default "__VITE_ASSET__CTa4DEwo__"